var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"deq-reset deq-crowd-verification-page"},[_c('h1',{staticClass:"title head"},[_vm._v("Crowd Verification")]),_c('CrowdSettingsPayPerBrandTable'),_c('MachineSetup'),_c('CrowdHistory')],1)}
var staticRenderFns = []

export { render, staticRenderFns }